




































import demo1 from './demo1.vue';
import demo2 from './demo2.vue';
import Anchor from '@/packages/d-anchor';
import Vue from 'vue';
import Component from 'vue-class-component';
import DButton from '@/packages/d-button';
import title from '../../packages/d-button/demo/README.md';

Vue.use(Anchor);
Vue.use(DButton);
@Component({
  name: 'ComponentDemo',
  components: {
    demo1, demo2
  }
})
export default class ComponentDemo extends Vue {
  public title = title;

  public getContainer() {
    return document.getElementById('app-content');
  }
}
